import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import {
  Breadcrumb,
  Header,
  Form,
  Radio,
  Input,
  Message,
  Segment,
  Label,
} from "semantic-ui-react";
import { ADMIN_CREATE_SUBSCRIPTION } from "../../GraphQL";
import { useMutation } from "@apollo/client";

const periodOptions = [
  { key: "month", value: "month", text: "monthly" },
  { key: "year", value: "year", text: "yearly" },
];

const NewSubscriptionPage = ({ history }) => {
  const [customerId, setCustomerId] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [quantity, setQuantity] = useState(1);
  const [endBehavior, setEndBehavior] = useState("release");
  const [period, setPeriod] = useState("year");
  const [amount, setAmount] = useState(4.99);
  const [periodAmount, setPeriodAmount] = useState(4.99);

  const [createSubscription, { loading }] = useMutation(
    ADMIN_CREATE_SUBSCRIPTION,
  );

  console.log("Start Date", startDate);

  const handleStartDateChange = (date) => {
    console.log("date", date);
    setStartDate(new Date(date.getTime() - date.getTimezoneOffset() * 60000));
  };
  const handleEndDateChange = (date) => {
    setEndDate(new Date(date.getTime() - date.getTimezoneOffset() * 60000));
  };

  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/admin">Admin Home</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section active>New Subscription</Breadcrumb.Section>
      </Breadcrumb>

      <Header as="h1">New Subscription</Header>

      <Segment attached="top">
        <Form
          onSubmit={() => {
            createSubscription({
              variables: {
                input: {
                  customerId,
                  startDate: startDate.toISOString().split("T")[0],
                  endDate: endDate.toISOString().split("T")[0],
                  quantity,
                  endBehavior,
                  period,
                  amount: amount * 100, // convert to cents,
                  periodAmount: amount * 100, // convert to cents,
                },
              },
              onCompleted: (data) => {
                console.log("completed", data);
                window.open(`https://dashboard.stripe.com/customers/${customerId}`, "_blank");
                setCustomerId("");
              },
              onError: (error) => {
                alert(error);
              }
            });
          }}
        >
          <Form.Input
            width={4}
            label="Customer ID"
            value={customerId}
            placeholder="cus_XXX"
            onChange={(e, { value }) => setCustomerId(value)}
          />
          <Form.Group widths="equal">
            <Form.Field>
              <label>Start date</label>
              <DatePicker
                utcOffset={0}
                selected={startDate}
                onChange={handleStartDateChange}
              />
            </Form.Field>
            <Form.Field>
              <label>End date</label>
              <DatePicker
                utcOffset={0}
                selected={endDate}
                onChange={handleEndDateChange}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field width={4}>
            <label>Number of users</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </Form.Field>
          <Form.Field width={4}>
            <label>Price per user (tax inclusive)</label>
            <Input
              labelPosition="left"
              type="text"
              placeholder="4.99"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            >
              <Label basic>$</Label>
              <input />
            </Input>
          </Form.Field>
          <Form.Field>
            <label>After end date:</label>
          </Form.Field>
          <Form.Field>
            <Radio
              label="Cancel subscription"
              name="endBehavior"
              value="cancel"
              checked={endBehavior === "cancel"}
              onChange={() => setEndBehavior("cancel")}
            />
          </Form.Field>
          <div className="flex-row">
            <Form.Field>
              <Radio
                label={{
                  children: ["Continue subscription, billing:"],
                }}
                name="endBehavior"
                value="release"
                checked={endBehavior === "release"}
                onChange={() => setEndBehavior("release")}
              ></Radio>
            </Form.Field>
            <Form.Select
              disabled={endBehavior !== "release"}
              width={3}
              value={period}
              onChange={(e, { value }) => {
                setPeriod(value);
              }}
              options={periodOptions}
            ></Form.Select>
            <Form.Field>at</Form.Field>
            <Form.Field width={2}>
              <Input
                disabled={endBehavior !== "release"}
                labelPosition="left"
                type="text"
                placeholder="4.99"
                value={periodAmount}
                onChange={(e) => setPeriodAmount(e.target.value)}
              >
                <Label basic>$</Label>
                <input />
              </Input>
            </Form.Field>
            <Form.Field>per user.</Form.Field>
            <Form.Field />
          </div>
          <Form.Button
            primary
            loading={loading}
            disabled={customerId.length === 0}
          >
            Create Subscription
          </Form.Button>
        </Form>
      </Segment>
      <Message attached="bottom" info>
        An invoice for{" "}
        <b>
          $
          {(quantity * amount).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </b>{" "}
        will automatically be generated and sent to the customer.
        {endBehavior === "release" ? (
          <p>
            After <b>{new Date(endDate).toLocaleDateString()}</b>, the customer
            will be billed every <b>{period}</b> for{" "}
            <b>
              $
              {(quantity * periodAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })}
            </b>
          </p>
        ) : (
          <p>
            After <b>{new Date(endDate).toLocaleDateString()}</b>, the
            subscription will automatically be canceled.
          </p>
        )}
      </Message>
    </div>
  );
};

export default withRouter(NewSubscriptionPage);
